// dev path
// export const API_BASE = "http://localhost:8001";
// export const SOCKET_BASE = "http://localhost:8001";
// export const HOME_URL = "http://localhost:3000";

//dev ssl 
// export const API_BASE = "https://localhost:5000";
// export const SOCKET_BASE = "https://localhost:5000";
// export const HOME_URL = "http://localhost:3000";

// LIVE path
export const API_BASE = "https://www.acadlance.com:5000";
export const SOCKET_BASE = "https://www.acadlance.com:5000";
export const HOME_URL = "https://www.acadlance.com";

//UAT path
// export const API_BASE = "https://www.uat.acadlance.com:8004";
// export const SOCKET_BASE = "https://www.uat.acadlance.com:8004";
// export const HOME_URL = "https://www.uat.acadlance.com";

const tazapayPath = (HOME_URL === "http://localhost:3000" ||
    HOME_URL?.includes('localhost') || HOME_URL?.includes('uat')) ?
    "https://js-sandbox.tazapay.com/v2.0-sandbox.js"
    : "https://js.tazapay.com/v2.0.js"

export const TAZAPAY = {
    url: tazapayPath
}

export const RAZORPAY = {
    url: "https://checkout.razorpay.com/v1/checkout.js"
}

export const BLOG_IMG_URL = API_BASE + "/blogImages/";
export const BLOG_AUTHOR_IMG_URL = API_BASE + "/blogImages/blogAuthor/";
export const ORDER_FILE_URL = API_BASE + "/orders/";
export const USER_FILES_URL = API_BASE + "/userFiles/";
export const SCAMALERT_FILES_URL = API_BASE + "/scam_attachments/";

// Admin API Endpoints
export const ADMIN_LOGIN = API_BASE + "/adminLogin";
export const ADMIN_USERS_API_URL = API_BASE + "/adminUsers";

export const BLOG_API_URL = API_BASE + "/blogs";
export const CANCEL_REASON_API_URL = API_BASE + "/cancelReason";
export const COUNTRY_API_URL = API_BASE + "/country";
export const HIGHEST_DEGREE_API_URL = API_BASE + "/highestDegree";
export const POLICY_API_URL = API_BASE + "/policy";
export const SERVICE_API_URL = API_BASE + "/service";
export const SKILLS_API_URL = API_BASE + "/skills";
export const SOFTWARE_REQUIRED_API_URL = API_BASE + "/softwareRequired";
export const SPECIALIZATION_API_URL = API_BASE + "/specialization";
export const SUBJECTS_API_URL = API_BASE + "/subjects";
export const ASSIGNMENT_TYPE_API_URL = API_BASE + "/assignment-type";
export const UNIVERSITY_API_URL = API_BASE + "/university";

// FrontEnd API Endpoints
export const HOME_API_URL = API_BASE + "/home";
export const PROFILE_API_URL = API_BASE + "/profile";

// User Dashboard API Endpoints
export const COMMON_API_URL = API_BASE + "/common";
export const USER_LOGIN_SIGNUP_URL = API_BASE + "/userLoginSignup";
// export const USER_GOOGLE_LOGIN_SIGNUP_URL = API_BASE + "/userGoogleLoginSignup";
export const POST_NEW_TASK_API_URL = API_BASE + "/postnewtask";
export const ACCOUNT_SETTINGS_API_URL = API_BASE + "/accountSettings";
export const MANAGE_CLIENT_ORDERS_API_URL = API_BASE + "/manageClientOrders";
export const MANAGE_EXPERT_ORDERS_API_URL = API_BASE + "/manageExpertOrders";
export const SEARCH_API_URL = API_BASE + "/search";
export const BID_API_URL = API_BASE + "/bid";
export const UPLOAD_ADDITIONAL_FILES_API_URL = API_BASE + "/uploadAdditionalFiles";
export const SUBMIT_FINAL_ASSIGNMENT_API_URL = API_BASE + "/finalAssignment";
export const NOTIFICATIONS_API_URL = API_BASE + "/notifications";
export const TRANSACTION_API_URL = API_BASE + "/transaction";
export const DISPUTE_API_URL = API_BASE + "/dispute";
export const REFERRAL_API_URL = API_BASE + "/referral";
export const TEST_API_URL = API_BASE + "/test-verification";

export const SCAMS_API_URL = API_BASE + "/scams"
